"use strict";
/**
 * Created by rouven on 09.03.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var BaseColumn = function (_a) {
    var className = _a.className, onClick = _a.onClick, children = _a.children, cellWidth = _a.cellWidth, cellIdAccessor = _a.cellIdAccessor, rowData = _a.rowData, idx = _a.idx;
    if (!rowData || !idx) {
        console.warn('when using BaseColumn, you should pass rowData and idx to it, omitting these props is deprecated');
    }
    var tdProps = {
        onClick: onClick,
        id: (cellIdAccessor && rowData && idx) ? cellIdAccessor(rowData, idx) : undefined
    };
    switch (typeof className) {
        case 'object':
            if (className.td) {
                tdProps.className = className.td;
            }
            break;
        case 'string':
            tdProps.className = className;
            break;
    }
    return (react_1["default"].createElement("td", __assign({}, tdProps), cellWidth ? (react_1["default"].createElement("div", { style: { 'width': cellWidth } }, children)) : children));
};
exports["default"] = BaseColumn;
